import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/useApi";
import { UnityClient } from "@lib/ShiOneClient";

export default function useGetCurrentUnityStatus() {
  const api = useApi(UnityClient);

  const fetch = async () => {
    return await api.getUnityStatus();
  }

  return useQuery({
    queryKey: ["current-unity-status"],
    queryFn: fetch,
  })
}